<template>
    <div>
        <award-list-link :listLayout="listLayout" :awardList="awardList" v-if="awardList.length > 0">
        </award-list-link>
        <award-empty-link :emptyLayout="emptyLayout" v-else></award-empty-link>
        <pagination-link :paginationLayout="paginationLayout"></pagination-link>
        <judgement-result-modal></judgement-result-modal>
    </div>
</template>

<script>
import awardUtil from "@/components/award/awardUtil";
import AwardListLink from "@/components/award/AwardListLink";
import AwardEmptyLink from "@/components/award/AwardEmptyLink";
import AwardFilterLink from "@/components/award/AwardFilterLink";
import PaginationLink from "@/components/award/PaginationLink";
import util from "@/mixins/util";
import JudgementResultModal from "@/components/modal/JudgementResultModal";

export default {
    name: "AwardListComponent",
    mixins: [awardUtil],
    components: {
        JudgementResultModal,
        AwardFilterLink,
        AwardListLink,
        AwardEmptyLink,
        PaginationLink,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {
        awardType: '',
        awardKey: '',
    },
    data() {
        return {
            listLayout: '',
            filterLayout: '',
            emptyLayout: '',
            paginationLayout: '',
            getFunc: '',
            listApiParamSet: {},
            getKeyName: 'cid',
            awardList: [],
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initConfig() {
            let awardConfig = this.returnAwardConfig(this.awardType);
            this.listLayout = awardConfig.listLayout;
            this.filterLayout = awardConfig.filterLayout;
            this.emptyLayout = awardConfig.emptyLayout;
            this.paginationLayout = awardConfig.paginationLayout;
            this.getFunc = awardConfig.getFunc
            this.listApiParamSet = awardConfig.listApiParamSet;
            this.getKeyName = awardConfig.getKeyName;
            this.getAward()
        },
        openModal(data) {
            this.$modal.show(data);
        },
        getAward() {
            let params = JSON.parse(JSON.stringify(this.listApiParamSet));
            if (!util.isEmpty(this.getKeyName)) {
                params[this.getKeyName] = this.awardKey;
            } else {
                params.cid = this.awardKey
            }
            try {
                this.$api.$competition[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type === 1) {
                        this.awardList = res.List
                    } else {

                    }
                })
            } catch (e) {

            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
